const contractMainDataActions = {
  CONTRACT_MAIN_DATA_INIT: 'CONTRACT_MAIN_DATA_INIT',
  CONTRACT_MAIN_DATA_SET: 'CONTRACT_MAIN_DATA_SET',
  CONTRACT_MAIN_DATA_PROP_SET: 'CONTRACT_MAIN_DATA_PROP_SET'
};

export default contractMainDataActions;